const STORAGE_KEY = 'v3me:last-seen-changelog-version';

export const releases = [
  {
    version: 'v3.4.0',
    date: 'July 2, 2026',
    title: 'Calendar Review',
    summary: 'Review your training history by day, so it is easier to find the workouts and log entries you are looking for.',
    videoUrl: '/changelog/videos/calendar-review.mp4?v=3.4.0-calendar-review',
    poster: null,
    highlights: [
      'Calendar days are shaded when they have logged activity.',
      'Tap any day to see the workouts and log entries saved for that date.',
      'Move between days without digging through one long workout list.',
      'Feature feedback is available directly from What’s New.',
    ],
  },
  {
    version: 'v3.3.0',
    date: 'June 29, 2026',
    title: 'Rest Timers',
    summary: 'Add rest timers to templates, adjust them during a workout, and let V3ME guide the next exercise when rest is complete.',
    videoUrl: '/changelog/videos/rest-timer.mp4?v=3.3.0-rest-timer-final-pass',
    poster: null,
    highlights: [
      'Rest timers can be enabled and configured in settings.',
      'Templates can include rest timers between movements.',
      'Workout timers support quick fifteen second adjustments.',
      'Optional automation can start timers and open the next exercise.',
    ],
  },
  {
    version: 'v3.2.34',
    date: 'June 28, 2026',
    title: 'Ideas, Votes, Surveys, and Bug Reports',
    summary: 'V3ME now collects product ideas, feature votes, survey ratings, and bug reports directly inside the app.',
    videoUrl: null,
    poster: null,
    highlights: [
      'Share Idea, Feature Feedback, Report Bug, and Send Feedback actions are available from the app menu.',
      'Users can vote on curated ideas without leaving V3ME.',
    ],
  },
  {
    version: 'v3.2.33',
    date: 'June 26, 2026',
    title: 'Previous Reps at a Glance',
    summary: 'Exercise rows now show previous full and partial rep counts before you open the editor, making it easier to compare your current set with recent history.',
    videoUrl: null,
    poster: null,
    highlights: [],
  },
  {
    version: 'v3.2.26',
    date: 'June 10, 2026',
    title: 'Cleaner Workout Drafts and Settings',
    summary: 'Untouched autosaved workout drafts are discarded instead of becoming empty completed workouts, and settings rows now use cleaner switches.',
    videoUrl: null,
    poster: null,
    highlights: [],
  },
  {
    version: 'v3.2.15',
    date: 'May 26, 2026',
    title: 'Better Max Reps History',
    summary: 'Max Reps history now works for selected bodyweight and non-band movements too, so more exercise types can show useful progress context.',
    videoUrl: null,
    poster: null,
    highlights: [],
  },
];

export const latestRelease = releases[0];

export function getLastSeenChangelogVersion() {
  return window.localStorage.getItem(STORAGE_KEY);
}

export function hasUnreadChangelogRelease() {
  return getLastSeenChangelogVersion() !== latestRelease.version;
}

export function markChangelogReleaseSeen(version = latestRelease.version) {
  window.localStorage.setItem(STORAGE_KEY, version);
  window.dispatchEvent(new CustomEvent('v3me:changelog-read-status-changed'));
}
